module.exports = __webpack_public_path__ + "static/img/contant_2.7a715a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_5/contant_2.png
// module id = 7g7+
// module chunks = 0